export const ACCOUNTING_MOVEMENT = "AsientoId";
